module.exports = __webpack_public_path__ + "img/discord.2405474e.svg";